import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Account, useSignInMutation } from 'api/sessionApi';
import { useRecoilState } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { getAcceptUserInfo } from 'util/commonUtil';
import { encryptString } from 'util/encryptUtil';

import ErrorMessage from './widget/ErrorMessage';

function SignIn() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Account>();
  const { mutate } = useSignInMutation();

  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const onSubmit: SubmitHandler<Account> = (data) => {
    mutate(data, {
      onSuccess(response) {
        if (response.code === 200) {
          const {
            account,
            name,
            latestDt,
            role,
            factoryId,
            deptId,
            acceptUsers,
          } = response.info;
          setUserInfo({
            account,
            local: '',
            role: encryptString(role),
            name,
            latestDt,
            isAuthenticated: true,
            factoryId: encryptString(factoryId),
            deptId: encryptString(deptId),
            ...getAcceptUserInfo(role, acceptUsers),
          });
          navigate('/home/status-board');
        } else {
          alert(response.message);
        }
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={'loginbox'}>
        <h2>{'LOTO'}</h2>
        <div className={'inputbox'}>
          <dl>
            <dt>{t('login.id')}</dt>
            <dd>
              <input
                type={'text'}
                {...register('account', { required: t('login.enterId') })}
              />
            </dd>
          </dl>
          <dl>
            <dt>{t('login.pw')}</dt>
            <dd>
              <input
                type={'password'}
                {...register('passwd', { required: t('login.enterPw') })}
              />
            </dd>
          </dl>
          <ErrorMessage errors={errors} />
          <button type={'submit'} className={'btn-type-login'}>
            {t('button.login')}
          </button>
        </div>
      </div>
    </form>
  );
}

export default SignIn;
